<template>
  <div id="menber_info" class="menber_control menber_nav padding-30">
    <TabBar :list="tabList" :active="tabActive" @active="active"/>
    <div class="b_cont">
      <div :class="'order_list order_' + [tabActive === 0 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="info_1 m-b-15" :class="{'move_bg':showBg}" @mouseout="showBg = false" @mouseover="showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_title">会员信息</div>
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-12 m-b-5" data-text="1"><strong>会员帐号：</strong><i>{{member.username}}</i></span>
                  <span class="cont2 col-xs-12 col-sm-12 m-b-5" data-text="2"><strong>会员等级：</strong><i>{{member.memberRank.name}}</i></span>
                  <span class="cont4 col-xs-12 col-sm-12 m-b-5" data-text="4"><strong>最后登录IP：</strong><i>{{member.loginIp}}</i></span>
                </div>
              </div>
            </div>
          </li>
          <li class="info_2 m-b-15" :class="{'move_bg':showBg1,'show_dialog':showDialog}" @mouseout="showBg1 = false" @mouseover="showBg1 = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div v-if="showDialog" class="info_com">请完善信息</div>
                <img src="/static/images/menber.jpg" class="m-b-15" width="100" height="100" style="display:none;"/>
                <div class="order_title m-b-5" v-if="!memberEdit" style="overflow:hidden;">{{member.name}}</div>
                <div class="order_title m-b-5" v-if="memberEdit" style="overflow:hidden;"> <input type="text" v-model="member.name" class="col-xs-12 col-sm-6"/> </div>

                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-12 m-b-5" data-text="1" ><strong style="float:left;">手机：</strong><i v-if="!memberEdit">{{member.mobile}}</i><i v-if="memberEdit"><input class="col-xs-12 col-sm-6" type="text" v-model="member.mobile"/></i></span>
                  <span class="cont2 col-xs-12 col-sm-12 m-b-5" data-text="2"><strong>性别：</strong><i v-if="!memberEdit"><span v-if="member.sex === '1'">男</span><span v-if="member.sex === '2'">女</span></i><i v-if="memberEdit"><select v-model="member.sex" v-on:change="changeSex"><option value="1">男</option><option value="2">女</option></select></i></span>
                  <span class="cont3 col-xs-12 col-sm-12 m-b-5" data-text="3"><strong>邮箱：</strong><i v-if="!memberEdit">{{member.email}}</i>
                    <i v-if="memberEdit"><input type="text" v-model="member.email"/> </i>
                  </span>
                  <span class="cont3 col-xs-12 col-sm-12 m-b-5" v-for="(item, index) in member.memberAttributeMapStore">
                    <strong><span v-if="item.att.isRequired === '01'">*</span>{{item.att.name}}：</strong>
                    <i v-if="!memberEdit">{{item.element}}</i>
                    <i v-if="memberEdit">
                      <input type="text" :name="item.id" v-model="item.element" v-if="item.att.attributeType === 'text' || item.att.attributeType === 'alphaint' || item.att.attributeType === 'date'"/>
                      <input type="number" :name="item.id" v-model="item.element" v-if="item.att.attributeType === 'number'"/>
                      <select v-model="item.element" v-if="item.att.attributeType === 'select'">
                        <option :value="key1" v-for="key1 in item.att.attributeOptionList">{{key1}}</option>
                      </select>
                      <span v-if="item.att.attributeType === 'checkbox'" class="memberCheckbox">
                        <label v-for="key2 in item.att.attributeOptionList"><input type="checkbox" @click="changeCheckout($event, item)" :name="item.att.attId" :value="key2" :checked="item.element.match(new RegExp(key2)) ? 'checked' : ''">{{key2}}</label>
                      </span>
                    </i>
                  </span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20" style="">
              <div class="col-xs-12 col-sm-12 col-md-6 m-b-15 order_btn">
                <a href="javascript:;" :class="memberEdit ? 'order_detail active_fix' : 'order_detail'" :style="{'background-color': memberEdit? $store.state.color : ''}" v-on:click="handleMemberEdit"><span v-if="!memberEdit">修改信息</span><span v-if="memberEdit">确认保存</span></a>
              </div>
            </div>
          </li>
          <li class="logout-li"><span @click="logout">退出登录</span></li>
        </ul>
      </div>
      <div :class="'order_list order_' + [tabActive === 1 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="m-b-15" :class="{'move_bg':showBg}" @mouseout="showBg = false" @mouseover="showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-12 m-b-5"><strong>旧　密　码：</strong><i><input v-model="oldpassword" name="text1" type="password" placeholder="请输入旧密码"></i></span>
                  <span class="cont2 col-xs-12 col-sm-12 m-b-5"><strong>新　密　码：</strong><i><input v-model="newpassword" name="text2" type="password" placeholder="请输入新密码(以字母开头，长度在6~18之间，只能包含字母、数字和下划线)"></i></span>
                  <span class="cont3 col-xs-12 col-sm-12 m-b-5"><strong>确认新密码：</strong><i><input v-model="comfirmpassword" name="text3" type="password" placeholder="请再次输入新密码"></i></span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-4 m-b-15 order_btn">
                <a href="javascript:;" class="order_add" v-on:click="savePassword">保存修改</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div :class="'order_list order_' + [tabActive === 2 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="m-b-15" :class="{'move_bg':showBg}" @mouseout="showBg = false" @mouseover="showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-12 m-b-5"><strong>安全问题：</strong><i><input v-model="member.safeQuestion" name="text1" type="text" placeholder="安全问题"></i></span>
                  <span class="cont2 col-xs-12 col-sm-12 m-b-5"><strong>回　　答：</strong><i><input v-model="member.safeAnswer" name="text2" type="text" placeholder="回　　答"></i></span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-4 m-b-15 order_btn">
                <a href="javascript:;" class="order_add" v-on:click="saveQuestion">保存修改</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TabBar from '@/components/TabBar'
export default {
  computed: {
    ...mapState(['info', 'enterpriseId'])
  },
  components: {
    TabBar
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$route.params.active) {
        vm.tabActive = vm.$route.params.active
      }
    })
  },
  created () {
    this.get()
  },
  data () {
    return {
      tabList: [
        {name: '个人信息'},
        {name: '密码修改'}
      ],
      tabActive: 0,
      memberEdit: false,
      member: {
        username: '未登录',
        memberId: 'ff808181555f4562015599f7d3ce0efc',
        memberRank: {
          name: '普通会员'
        },
        loginIp: '127.0.0.1',
        name: '会员昵称',
        mobile: '',
        sex: '1',
        email: '',
        memberAttributeMapStore: [
        ]
      },
      showBg: false,
      showBg1: false,
      oldpassword: '',
      newpassword: '',
      comfirmpassword: '',
      showDialog: false
    }
  },
  methods: {
    active (index) {
      this.tabActive = index
    },
    logout () {
      window.$.ajax({
        url: 'http://www.jihui88.com/rest/api/shop/member/logout?userDomain=' + document.domain,
        dataType: 'jsonp',
        async: false,
        jsonpCallback: 'jsonpCallbacks',
        success: function (response) {
        }
      })
      window.location.reload()
    },
    get () {
      var ctx = this
      console.log('enterpriseId=' + this.enterpriseId)
      console.log('enterpriseId=' + this.$route.query.account)
      if (!this.info.data.username) {
        window.$.ajax({
          url: '/rest/api/shop/member/info',
          async: false,
          data: {
            enterpriseId: this.enterpriseId
          },
          success (res) {
            if (res.success) {
              ctx.$store.commit('setInfo', res.attributes)
            } else {
              // window.alert('noLogin')
            }
          }
        })
      }

      console.log('memberId=' + this.info.data.memberId)
      this.member.memberAttributeMapStore.forEach(item => {
        if (item.att.isEnabled === '01') {
          item.element = item.element.substring(1, item.element.length - 1)
        }
      })
      window.$.ajax({
        url: 'http://www.jihui88.com/rest/api/shop/member/detail/' + this.info.data.memberId,
        success (res) {
          if (res.success) {
            var data = res.attributes.data
            if (data.memberAttributeMapStore.length > 0) {
              data.memberAttributeMapStore.forEach(item => {
                if (item.att.isEnabled === '01') {
                  item.element = item.element.substring(1, item.element.length - 1)
                  if (item.element === '') {
                    ctx.showDialog = true
                    ctx.memberEdit = true
                  }
                }
              })
            }
            ctx.member = data
          }
        }
      })
    },
    handleMemberEdit () {
      var ctx = this
      if (ctx.memberEdit) {
        let model = {
          name: ctx.member.name,
          email: ctx.member.email,
          mobile: ctx.member.mobile,
          sex: ctx.member.sex
        }
        if (ctx.member.memberAttributeMapStore) {
          ctx.member.memberAttributeMapStore.forEach(item => {
            if (item.att.isEnabled === '01') {
              model[item.att.attId] = item.element
            }
          })
        }
        window.$.ajax({
          type: 'post',
          url: 'http://www.jihui88.com/rest/api/shop/member/detail/' + ctx.info.data.memberId,
          data: {
            model: JSON.stringify(model),
            _method: 'put'
          },
          success (res) {
            if (res.success) {
              ctx.memberEdit = !ctx.memberEdit
              ctx.showDialog = false
            } else {
              window.alert(res.msg)
            }
          }
        })
      } else {
        ctx.memberEdit = true
      }
    },
    changeSex (event) {
      this.member.sex = window.$(event.target).find('option:selected').val()
    },
    changeCheckout (e, item) {
      if (e.target.checked) {
        item.element = item.element + ',' + e.target.value
      } else {
        var arr = item.element.split(',')
        arr.forEach((item, index) => {
          if (item === e.target.value) {
            arr.splice(index, 1)
          }
        })
        item.element = arr.join()
      }
    },
    savePassword (event) {
      if (this.newpassword !== this.comfirmpassword) {
        window.alert('两次密码不匹配')
        return
      }
      window.$.ajax({
        type: 'post',
        url: 'http://www.jihui88.com/rest/api/shop/member/password/detail/' + this.info.data.memberId,
        data: {
          model: JSON.stringify({
            newpassword: this.newpassword,
            oldpassword: this.oldpassword
          }),
          _method: 'put'
        },
        success (res) {
          if (res.success) {
            window.alert('修改成功')
          } else {
            window.alert(res.msg)
          }
        }
      })
    },
    saveQuestion (event) {
      window.$.ajax({
        type: 'post',
        url: ' http://www.jihui88.com/rest/api/shop/member/safe/detail/' + this.info.data.memberId,
        data: {
          model: JSON.stringify({
            safeQuestion: this.member.safeQuestion,
            safeAnswer: this.member.safeAnswer
          }),
          _method: 'put'
        },
        success (res) {
          if (res.success) {
            window.alert('修改成功')
          } else {
            window.alert(res.msg)
          }
        }
      })
    }
  }
}
</script>

<style lang="css">
/*我的钱包*/
#menber_pay .order_list .order_cont>span>i {
	font-style:normal;
}
#menber_pay .order_list .order_cont>span input {
	background:none;
	border:1px solid #eee;
	margin:0;
	padding:0;
	display:inline-block;
	width:80%;
	font-size:14px;
	line-height:2;
	outline:0;
	text-indent:3%;
}
#menber_pay .order_list .order_cont>span select {
	background:none;
	border:1px solid #eee;
	padding:0;
	font-size:14px;
	height:30px;
}
#menber_pay .order_list .order_cont>span strong {
	float:left;
}
/*修改个人信息*/
#menber_info .order_list .info_1 .order_h {
	border-bottom:0 none;
}
.show_dialog .order_h {
    overflow: auto !important;
}
.show_dialog{
  overflow:auto !important;
}
#menber_info .order_list .info_1 .order_cont span {
	border-bottom:1px solid #eee;
}
#menber_info .order_list .order_detail.active_fix {
	background: #62a8ea;
    border-color: #62a8ea;
    color: #fff;
}
#menber_info .order_list .order_title input {
	background:none;
	border:1px solid #eee;
	margin:0;
	padding:0;
	display:inline-block;
	width:40%;
	font-size:14px;
	line-height:2;
	outline:0;
	text-indent:3%;
}
#menber_info .order_list .order_cont>span>i {
	font-style:normal;
}
#menber_info .order_list .order_cont>span input {
	background:none;
	border:1px solid #eee;
	margin:0;
	padding:0;
	display:inline-block;
	width:80%;
	font-size:14px;
	line-height:2;
	outline:0;
	text-indent:3%;
}
#menber_info .order_list .order_cont .memberCheckbox label{
  padding-right: 10px
}
#menber_info .order_list .order_cont .memberCheckbox input{
  width: auto;
  margin-right: 5px;
}
.menber_control .show_dialog{
position: fixed;
top: 20px;
left: 5%;
width: 90%;
height: 90%;
z-index: 9999;
    background-color: #fff;
    box-shadow: 0px 0px 13px 0px #999;
}
.info_com{    padding-bottom: 5px;
    font-size: 20px;}
.logout-li span{
  display: inline-block;
    width: 100%;
    height: 50px;
    background-color: #f33535;
    color: #fff;
    font-size: 2rem;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Info.vue